import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  Button,
  Popover,
} from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import CustomTypography from "../../globalStyles/fonts";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import TransactionDetailsModal from "../transactionDetailsModal";
import { isMobile } from "../../globalStyles/mobile";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ViewIcon from "../../globalStyles/icons/vieewIcon";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import CustomPagination from "../pagination";

const TransactionList = ({
  viewMode,
  data,
  setPage,
  setRowsPerPage,
  rowsPerPage,
  page,
  dataCount,
  selectedTransaction,
  setSelectedTransaction,
}) => {
  const [transactionData, setTransactionData] = useState([]);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0 });
  const startIndex = rowsPerPage * page;

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "var(--table-header-bg)",
      border: "none",
      padding: "4px",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
      padding: "4px",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "var(--row-bg-odd)",
      border: "1px solid var(--border-color)",
    },
    "&:nth-of-type(even)": {
      backgroundColor: "var(--row-bg-even)",
      border: "1px solid var(--border-color)",
    },
    "&:lastChild td, &:lastChild th": {
      border: 0,
    },
  }));

  const handleViewClick = (transaction) => {
    setSelectedTransaction(transaction);
    setOpenViewModal(true);
  };
  const handlePopoverOpen = (event, item) => {
    setSelectedTransaction(item);
    setAnchorEl(event.currentTarget);
    setAnchorPosition({
      top: event.clientY - 15,
      left: event.clientX - 15,
    });
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const Action = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "8px",
        }}
      >
        <Button
          style={{
            color: "var(--text-tertiary)",
            justifyContent: "flex-start",
            textTransform: "none",
          }}
          aria-label="view"
          onClick={() => {
            handleViewClick(selectedTransaction);
            handlePopoverClose();
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            width="100%"
            gap={1}
          >
            <ViewIcon />
            <Typography
              fontFamily={"poppins"}
              fontSize={"16px"}
              color={"var(--text-tertiary)"}
              fontWeight={500}
            >
              View
            </Typography>
          </Box>
        </Button>
      </div>
    );
  };
  useEffect(() => {
    setTransactionData(
      data?.map((item) => ({
        ...item,
        action: (
          <Box>
            <IconButton
              aria-label="more actions"
              onClick={(e) => {
                handlePopoverOpen(e, item);
              }}
              sx={{
                color:
                  anchorEl && selectedTransaction?._id === item._id
                    ? "primary.main"
                    : "inherit",
                // position: "relative",
              }}
            >
              <MoreVertIcon />
            </IconButton>
            <Popover
              anchorReference="anchorPosition"
              anchorPosition={anchorPosition}
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              disableRestoreFocus
              sx={{
                "& .MuiPaper-root": {
                  boxShadow: "none",
                  border: "1px solid var(--border-color)",
                  borderRadius: "4px",
                  zIndex: 1300,
                },
              }}
            >
              <Action />
            </Popover>
          </Box>
        ),
      })),
    );
  }, [data, anchorEl]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const renderGridView = () => (
    <Grid sx={{ padding: 1, marginTop: 1 }} container spacing={2}>
      {transactionData?.map((x) => (
        <Grid item xs={12} sm={6} md={3} key={x._id}>
          <Card sx={{ boxShadow: 3, cursor: "pointer" }}>
            <CardContent>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    alignItems: "flex-start",
                    width: "70%",
                    display: "flex",
                    flexDirection: "column",
                    // marginLeft: 15,
                  }}
                >
                  <Tooltip title={x?.order_id} arrow>
                    <div
                      style={{
                        fontWeight: "500",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                        overflow: "hidden",
                      }}
                    >
                      <Typography style={{ fontWeight: "500" }} variant="h7">
                        Order Id :{x?.order_id}
                      </Typography>
                    </div>
                  </Tooltip>
                  <Tooltip title={x?.order_number} arrow>
                    <div
                      style={{
                        fontWeight: "500",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: "80%",
                        overflow: "hidden",
                      }}
                    >
                      <Typography style={{ fontWeight: "500" }} variant="h7">
                        Order Number :{x?.order_number}
                      </Typography>
                    </div>
                  </Tooltip>
                  <Tooltip title={x?.order_number} arrow>
                    <div
                      style={{
                        fontWeight: "500",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: "70%",
                        overflow: "hidden",
                      }}
                    >
                      <Typography style={{ fontWeight: "500" }} variant="h7">
                        Shipping Cost :{x?.shipment_cost}
                      </Typography>
                    </div>
                  </Tooltip>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "30%",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {x.action}
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_rateCard.png"
        alt="No data available"
        style={{ objectFit: "fill", height: "300px" }}
      />
    </div>
  );
  const MobileCardView = ({ data }) => {
    return (
      <Box sx={{ width: "100%", padding: 0.5 }}>
        {transactionData.length === 0 ? (
          <NoDataImage />
        ) : (
          transactionData?.map((x, index) => (
            <Card
              key={index}
              sx={{
                marginBottom: 2,
                backgroundColor: "#ffff",
                borderRadius: 4,
              }}
            >
              <CardContent>
                <div style={{ width: "100%" }}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                  >
                    <Grid container spacing={2} sx={{ marginTop: 1 }}>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="var(--text-tertiary)"
                          fontWeight={600}
                          textAlign="left"
                        >
                          Order Id
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="Poppins"
                          color="#606060"
                          fontWeight={500}
                          noWrap
                          overflow="hidden"
                          textOverflow="ellipsis"
                          textAlign="left"
                        >
                          : {x?.order_id}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="var(--text-tertiary)"
                          fontWeight={600}
                          textAlign="left"
                        >
                          Order Number
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="Poppins"
                          color="#606060"
                          fontWeight={500}
                          noWrap
                          overflow="hidden"
                          textOverflow="ellipsis"
                          textAlign="left"
                        >
                          : {x?.order_number}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="var(--text-tertiary)"
                          fontWeight={600}
                          textAlign="left"
                        >
                          Status
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="Poppins"
                          color="#606060"
                          fontWeight={500}
                          noWrap
                          overflow="hidden"
                          textOverflow="ellipsis"
                          textAlign="left"
                        >
                          : {x?.status}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="var(--text-tertiary)"
                          fontWeight={600}
                          textAlign="left"
                        >
                          Shipment Cost
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="Poppins"
                          color="#606060"
                          fontWeight={500}
                          noWrap
                          overflow="hidden"
                          textOverflow="ellipsis"
                          textAlign="left"
                        >
                          : {x?.shipment_cost}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box mt={1} justifyContent={"flex-end"} display="flex">
                    {x?.action}
                  </Box>
                </div>
              </CardContent>
            </Card>
          ))
        )}
      </Box>
    );
  };

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        overflow: isMobile() ? "auto" : "hidden",
        paddingBottom: 20,
      }}
    >
      {isMobile() ? (
        <MobileCardView data={data} />
      ) : (
        <TableContainer
          className="custom-container"
          sx={{
            overflowY: "auto",
            paddingInline: 0.4,
            maxHeight: "100%",
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              border: "1px solid var(--border-color)",
            }}
          >
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    SL NO
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    Client
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    Order Id
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    Order Number
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    Status
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    Shipment Cost
                  </Typography>
                </StyledTableCell>

                <StyledTableCell>
                  <CustomTypography
                    fontSize="14px"
                    title={true}
                    color="var(--text-tertiary)"
                    fontWeight={500}
                  ></CustomTypography>
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {transactionData?.map((x, index) => (
                <React.Fragment>
                  <StyledTableRow key={index}>
                    <StyledTableCell>
                      <Typography
                        fontSize="12px"
                        color="var(--text-secondary)"
                        fontWeight={400}
                        fontFamily={"Poppins"}
                      >
                        {startIndex + index + 1}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        fontSize="12px"
                        color="var(--text-secondary)"
                        fontWeight={400}
                        fontFamily={"Poppins"}
                      >
                        {x?.client_id?.business_name || x?.client_id?.name}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        fontSize="12px"
                        color="var(--text-secondary)"
                        fontWeight={400}
                        fontFamily={"Poppins"}
                      >
                        {x?.order_id}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        fontSize="12px"
                        color="var(--text-secondary)"
                        fontWeight={400}
                        fontFamily={"Poppins"}
                      >
                        {x.order_number}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        fontSize="12px"
                        color="var(--text-secondary)"
                        fontWeight={400}
                        fontFamily={"Poppins"}
                      >
                        {x.status}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        fontSize="12px"
                        color="var(--text-secondary)"
                        fontWeight={400}
                        fontFamily={"Poppins"}
                      >
                        {x.shipment_cost}
                      </Typography>
                    </StyledTableCell>

                    <StyledTableCell sx={{ width: "3%", textAlign: "center" }}>
                      {x?.action}
                    </StyledTableCell>
                  </StyledTableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );

  return (
    <>
      <div sx={{ minWidth: "100%" }}>
        <div
          style={{
            overflowY: "scroll",
            display: "flex",
            maxHeight: "70vh",
            width: "100%",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::WebkitScrollbar": { width: 0 },
          }}
        >
          {viewMode === "grid" ? renderGridView() : renderListView()}
        </div>
        <CustomPagination
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          dataCount={dataCount}
          disableNext={dataCount <= rowsPerPage * (page + 1)}
        />

        <TransactionDetailsModal
          transaction={selectedTransaction}
          open={openViewModal}
          onClose={() => setOpenViewModal(false)}
        />
      </div>
    </>
  );
};

export default TransactionList;
